import Cookies from 'universal-cookie';

export function authHeader() {
  const cookies = new Cookies();
  const validToken = cookies.get('access_token');

  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + (validToken && validToken)
  };
}

export function refreshTokenHeader() {
  const cookies = new Cookies();
  const validRefreshToken = cookies.get('refresh_token');

  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + (validRefreshToken && validRefreshToken)
  };
}

export function accessToken() {
  const cookies = new Cookies();
  const validAccessToken = cookies.get('access_token');

  return validAccessToken;
}
